import { getConsumerFor } from "./consumer";
import {Subscription} from "@rails/actioncable";

export class CeremonyChannelSubscription {
  public subscription: Subscription;

  constructor(orchestratorId: number, { received, connected = undefined, disconnected = undefined }, votingRoundReportId?: number, scope?: 'ceremony') {
    this.subscription = getConsumerFor(null).subscriptions.create(
      {
        channel: 'CeremonyChannel',
        orchestrator_id: orchestratorId,
        voting_round_report_id: votingRoundReportId,
        // 'ceremony' asks for just the trustees and the ceremony state, skipping the election's
        // result history. Without it the server sends everything, which the trustee app needs.
        scope: scope
      },
      {
        received,
        connected,
        disconnected,
      },
    );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }

  fetchStatus() {
    this.subscription.perform('status');
  }
}